<p-toast key="remotePowerDetails"></p-toast>

<div id="remote-power-details">
  <p class="title">Tip analize</p>
  <p-select
    class="dropdown"
    [options]="analyseOptions"
    [(ngModel)]="selectedAnalyse"
    optionLabel="ime_analize"
    [optionDisabled]="'disabled'"
    [appendTo]="'body'"
    styleClass="dropdown-select grey-select-root"
    [pt]="{ overlay: { class: 'rp-compact-overlay' } }"
    (onChange)="onAnalyseSelectClick($event.value)">
  </p-select>

  <div *ngIf="selectedAnalyse.id == 1">
    <p class="title">Tehnologije</p>
    <p-select
      class="dropdown"
      [options]="techOptions"
      [(ngModel)]="selectedTechOption"
      optionLabel="ime_tehnologije"
      [appendTo]="'body'"
      styleClass="dropdown-select grey-select-root"
      [pt]="{ overlay: { class: 'rp-compact-overlay' } }"
      (onChange)="onTechSelectClick($event.value)">
    </p-select>
  </div> 

  <div *ngIf="selectedAnalyse.id == 2">
    <p class="title">Dodatni kriteriji</p>
    <p-select
      class="dropdown"
      [options]="criteriaOption"
      [(ngModel)]="selectedCriteriaOption"
      optionLabel="ime_kriterija"
      [appendTo]="'body'"
      styleClass="dropdown-select grey-select-root"
      [pt]="{ overlay: { class: 'rp-compact-overlay' } }"
      (onChange)="onCriteriaSelectClick($event.value)">
    </p-select>
  </div> 

  <div *ngIf="selectedAnalyse.id == 3">
    <form [formGroup]="remotePowerDetailsForm">
      <p class="title">Kriterij<span style="float: right;">Pomembnost kriterija [%]</span></p>

    <label class="container">
      <input type="checkbox" formControlName="isShareCheapestSystem">
      <span class="checkmark"></span>
      <p class="label">Najcenejši sistem - investicija [€]</p>
      <input (keydown)="preventNonNumeric($event)" *ngIf="this.remotePowerDetailsForm.get('isShareCheapestSystem').value" formControlName="shareCheapestSystem"
        type="number" min="0" max="100" id="mynumber" class="consumption-value slider-value">
    </label>

    <label class="container">
      <input type="checkbox" formControlName="isShareCheapetHeat4Consumer">
      <span class="checkmark"></span>
      <p class="label">Najcenejša toplota za odjemalce [€/kWh]</p>
      <input (keydown)="preventNonNumeric($event)" *ngIf="this.remotePowerDetailsForm.get('isShareCheapetHeat4Consumer').value"
        formControlName="shareCheapetHeat4Consumer" type="number" min="0" max="100" id="mynumber"
        class="consumption-value slider-value">
    </label>
    <label class="container">
      <input type="checkbox" formControlName="isShareLowestCo2Emissions">
      <span class="checkmark"></span>
      <p class="label">Najmanjše emisije CO<sub>2</sub> [kg/leto]</p>
      <input (keydown)="preventNonNumeric($event)" *ngIf="this.remotePowerDetailsForm.get('isShareLowestCo2Emissions').value"
        formControlName="shareLowestCo2Emissions" type="number" min="0" max="100" id="mynumber"
        class="consumption-value slider-value">
    </label>
    <label class="container">
      <input type="checkbox" formControlName="isShareMinConsumtionBasicEnergy">
      <span class="checkmark"></span>
      <p class="label">Najmanjša raba primarne energije [kWh/leto]</p>
      <input (keydown)="preventNonNumeric($event)" *ngIf="this.remotePowerDetailsForm.get('isShareMinConsumtionBasicEnergy').value"
        formControlName="shareMinConsumtionBasicEnergy" type="number" min="0" max="100" id="mynumber"
        class="consumption-value slider-value">
    </label>
    <label class="container">
      <input type="checkbox" formControlName="isShareMaxOVEShare">
      <span class="checkmark"></span>
      <p class="label">Največji delež OVE [%]</p>
      <input (keydown)="preventNonNumeric($event)"  *ngIf="this.remotePowerDetailsForm.get('isShareMaxOVEShare').value" formControlName="shareMaxOVEShare"
        type="number" min="0" max="100" id="mynumber" class="consumption-value slider-value">
    </label>
    </form>
   
  </div>

  <button class="button" *ngIf="!isLoading" (click)="onSubmit()" type="submit">Najdi</button>
  <p-progressBar *ngIf="isLoading" [value]="progressValue" [style]="{'height': '6px'}"></p-progressBar>

</div>
